import { DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.css'],
  standalone: false
})
export class SuccessModalComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { successMessage: string },
    private dialog: MatDialog,
    private dialogRef: DialogRef<SuccessModalComponent>
  ) {}

  closeModal() {
    this.dialogRef.close();
  }
 
  
  ngOnInit(): void {
  }
}
